module.exports = __webpack_public_path__ + "de53b013811f592a1fc985445ea324da.svg";